export class RentalDetail {
    public ID: number;
    public HashCode: string;
    public SchoolID: number;
    public RelationWithOwner: string;
    public YearlyRentAmountBuilding:number;
    public YearlyRentAmountPlayGround:number;
    public DurationOfRentDeed:number;
    public DateOfRentDeed:number;
    public LastThreeYearRentAmount:number;
    public BankName:any;
    public Branch:any;
    public AccountHolderName:any;
    public AccountNumber:number;
    public YearID:number;
}